import { jsx as _jsx } from "react/jsx-runtime";
import { Root, Item, Link, Skeleton } from "./CardButton.components.js";
export const CardButtonAtomComponent = ({ children, onClick, slotProps, isLoading, href, ...props }) => {
    const withLink = !!href?.trim();
    const contents = !isLoading ? (_jsx(Item, { "data-testid": "CardMenuItem", ...slotProps?.item, onClick: onClick, disabled: isLoading, children: children })) : (_jsx(Skeleton, { "data-testid": "CardMenuItemLoader", variant: "rectangular", animation: "wave", ...slotProps?.skeleton }));
    return (_jsx(Root, { "data-testid": "CardMenu", ...props, slotProps: {
            card: { sx: { padding: 0 } },
        }, children: withLink && !isLoading ? (_jsx(Link, { "data-testid": "CardMenuLink", href: href?.trim(), children: contents })) : (contents) }));
};
export default CardButtonAtomComponent;
